import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Loader2, Languages, ChevronRight, FileText, BookOpen, Layers } from 'lucide-react';
import { API_BASE as API } from '../config/api';
import axios from 'axios';

const SharedLinkPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [conlang, setConlang] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConlang = async () => {
      try {
        const res = await axios.get(`${API}/conlangs/shared-link/${token}`);
        setConlang(res.data);
      } catch {
        setError('This share link is invalid or has been revoked.');
      } finally { setLoading(false); }
    };
    fetchConlang();
  }, [token]);

  if (loading) return <div className="flex items-center justify-center min-h-screen bg-background"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;
  if (error) return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background gap-4">
      <Languages className="w-12 h-12 text-foreground-subtle" />
      <p className="text-foreground-muted">{error}</p>
      <Button onClick={() => navigate('/')}>Go Home</Button>
    </div>
  );

  return (
    <div className="min-h-screen bg-background p-8" data-testid="shared-link-page">
      <div className="max-w-3xl mx-auto">
        <Card className="bg-background-paper border-border mb-6">
          <CardHeader>
            <div className="flex items-center gap-2 text-foreground-subtle text-sm mb-2">
              <Languages className="w-4 h-4" />
              <span>Shared Language (View Only)</span>
            </div>
            <CardTitle className="font-heading text-3xl text-foreground">{conlang.name}</CardTitle>
            {conlang.native_name && <p className="text-foreground-muted font-mono text-lg">{conlang.native_name}</p>}
          </CardHeader>
          <CardContent className="space-y-4">
            {conlang.description && <p className="text-foreground-muted">{conlang.description}</p>}
            {conlang.creator && <p className="text-foreground-subtle text-sm">Creator: {conlang.creator}</p>}
            {conlang.owner_name && <p className="text-foreground-subtle text-sm">Documented by: {conlang.owner_name}</p>}
            <div className="grid grid-cols-3 gap-4 pt-4 border-t border-border">
              <div className="text-center"><p className="text-2xl font-bold text-foreground">{conlang.phoneme_count || 0}</p><p className="text-xs text-foreground-subtle">Phonemes</p></div>
              <div className="text-center"><p className="text-2xl font-bold text-foreground">{conlang.word_count || 0}</p><p className="text-xs text-foreground-subtle">Words</p></div>
              <div className="text-center"><p className="text-2xl font-bold text-foreground">{conlang.text_count || 0}</p><p className="text-xs text-foreground-subtle">Texts</p></div>
            </div>
            {conlang.about && (
              <div className="pt-4 border-t border-border">
                <h3 className="text-foreground font-semibold mb-2">About</h3>
                <p className="text-foreground-muted text-sm whitespace-pre-wrap">{conlang.about}</p>
              </div>
            )}
          </CardContent>
        </Card>
        <div className="text-center">
          <Button variant="outline" onClick={() => navigate('/login')} className="border-border">
            Log in to explore more
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SharedLinkPage;
